import React from 'react'
import Helmet from 'react-helmet'

import CustomHelmet from '../components/CustomHelmet'
import Apply from '../components/Apply'
import Hero from '../components/DayInTheLife/Hero'
import Introduction from '../components/DayInTheLife/Introduction'
import MoreFellows from '../components/DayInTheLife/MoreFellows'
import Fellows from '../components/Fellows'
import Times from '../components/DayInTheLife/Times'

class DayInTheLife extends React.Component {

  componentDidMount() {
    const ScrollReveal = require('scrollreveal')
    window.setTimeout(() => {
      window.sr = ScrollReveal();
      sr.reveal('.time', { duration: 600, scale: 1})
      sr.reveal('.times-image', { duration: 1600, opacity: 0.4, scale: 0.9, delay: -200})
    }, 200)
  }

  render() {
    const { data: { page } } = this.props;
    const seoKeywords = page.seoData && page.seoData.keywords ? page.seoData.keywords.toString() : ``;

    return (
      <div className="day">
        <CustomHelmet data={ page.seoData } />
        <Hero
          title={page.title}
          backgroundImage={page.heroImage}
          text={page.heroText}
        />
        <Introduction
          title={page.introductionTitle}
          text={page.introductionText.introductionText}
          videoBool={page.videoBool}
          videoLink={page.videoLink}
          mediaAsset={page.introductionMedia}
        />
        <Times
          times={page.scheduleCards}
        />
        <MoreFellows
          cards={page.fellowsCards}
        />
        <Apply
          title={'Curious about Global Citizen Year? This is a great place to start.'}
        />
      </div>
    );
  }
}

export default DayInTheLife

export const query = graphql`
  query DayInTheLifeTemplateQuery($id: String!) {
    page: contentfulDayInTheLife(id: { eq: $id }) {
      id
      slug
      title
      heroText
      heroImage {
  	    file {
          url
          contentType
          fileName
        }
        title
      }
      introductionTitle
      introductionText {
        introductionText
      }
      videoBool
      videoLink
      introductionMedia {
          sizes(quality:100, maxWidth:1800) {
              ...GatsbyContentfulSizes_withWebp
          }
        file {
          url
          contentType
          fileName
        }
        title
      }
      scheduleCards {
        time
        title
        text {
          text
        }
        image {
          file {
            url
            contentType
            fileName
          }
          title
        }
      }
      fellowsCards {
        fellowsName
        fellowsLocation
        image {
            sizes(quality:100, maxWidth:800) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        fellowsLink {
          link
          text
        }
        fellowsQuote {
          fellowsQuote
        }
      }
      seoData {
        pageTitle
        pageDescription {
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          openGraphDescription
        }
        openGraphImage {
          file {
            url
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/day-in-the-life.js